import { useParsedParam } from '@/core/hooks/useRouteParams'
import { useController } from '@/core/hooks/useSWRApi'
import {
  BracketKind,
  MatchmTicketControllerApi
} from '@rallycry/api-suite-typescript'
import useSWR from 'swr'
import { useBracket } from '../bracket/useBracket'
import { useCompetition } from '../competition/useCompetition'
import { EntityOptions } from '../useEntity'

const allowedBracketKinds: BracketKind[] = [
  BracketKind.LADDER,
  BracketKind.SWISS_LADDER
]

export const useBracketMatchmModTicket = (options?: EntityOptions<any>) => {
  const { ctrl: ticketCtrl } = useController(MatchmTicketControllerApi)
  const { isCompetitionModerator } = useCompetition()
  const { bracket, bracketSettings } = useBracket()
  const bracketKind = bracketSettings?.kind
  const parsedId = useParsedParam('bracketId')

  const bracketId = Number(options?.idOrKey) || parsedId

  const canFetch =
    isCompetitionModerator &&
    (allowedBracketKinds.includes(bracketKind!) ||
      (bracketKind === BracketKind.CUSTOM && bracket?.syncToMatchm))

  const { data: ticket, mutate: refreshTicket } = useSWR(
    canFetch ? `useMatchmModTicket` : undefined,
    async () => {
      const { ticket } = await ticketCtrl().obtainMatchmModTicket({
        bracketId
      })
      return ticket
    },
    {
      onError: error => {
        console.error('Error fetching Matchm mod ticket:', error)
      },
      refreshInterval: 60000 // Refresh every minute
    }
  )

  return { ticket, refreshTicket }
}
